import { useState, useContext, useEffect } from "react";
import { DataContext } from "../../context/data-context";
import DropDownSelector from "../UI/DropDownSelector";
import BarGraph from "../UI/BarGraph";
import { getVehicleStats } from "../../api/fetch";
import { AuthContext } from "../../context/auth-context";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";

export default function VehicleRevenue() {
  const { vehicles } = useContext(DataContext);
  const { user } = useContext(AuthContext);

  // Create Ids Array for DropDownSelector 
  const ids = vehicles.map((vehicle) => {
    return {
      value: vehicle.id,
      label: `${vehicle.model} ${vehicle.year} ${vehicle.license}`,
      image: vehicle.images.corner,
    };
  });

  // Initialize States
  const [selected, setSelected] = useState(ids.map((vehicle) => vehicle.value));
  const [selectedYear, setSelectedYear] = useState("2024");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // ============================================= FETCH REVENUE FOR VEHICLES
  const fetchVehicleRevenueHandler = async () => {
    try {
      setLoading(true);
      const data = await getVehicleStats(user, {
        vehicles: selected,
        year: selectedYear,
      });

      // Add Zero revenue for months with no revenue
      if (data.length < 12) {
        const length = data.length;
        for (let i = 0; i < (12 - length); i++) {
          const date = new Date()
          date.setMonth(length + i);
          const month = date.toLocaleString("default", { month: "short" });
          data.push({ name: month, revenue: 0 });
        }
      }
      setData(data);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVehicleRevenueHandler();
  }, []);

  if (loading) return <div className="h-[390px]">
      <LoadingSpinnerWrapper />
  </div>;

  return (
    <div>
      <div className="grid grid-cols-3 gap-8">
        <DropDownSelector
          label="Select Vehicles"
          options={ids}
          selected={selected}
          setSelected={setSelected}
        />
        <select
          className="text-sm border-b border-yellow-600 rounded-none cursor-pointer input"
          defaultValue={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
        >
          <option value="2022">2022</option>
          <option value="2023">2023</option>
          <option value="2024">2024</option>
        </select>
        <div
          onClick={fetchVehicleRevenueHandler}
          className="text-sm btn-tertiary"
        >
          Apply
        </div>
      </div>
      <BarGraph data={data} />
    </div>
  );
}
